import slugify from 'slugify'

export default function slugifyFn(text) {
  return slugify(text, {
    lower: true,
    strict: true,
  })
}
